import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initializeI18n } from './i18n/catalog'
import './styles.css'

initializeI18n()

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>,
)
